import React from "react";
import "./RiskFilters.css";

export default function RiskFilters({
  filters,
  handleChange,
  resetFilters,
  searchQuery,
  handleSearch,
  handleCollapseReset,
  totalCount,
  totalAll,
  onAddNew,
  onAddRessource,
  onAddMenace,
  onAddMesure
}) {
  return (
    <div className="riskfilters-container">
      <div className="riskfilters-header d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
        <span className="riskfilters-count">
          {totalCount} of {totalAll} Risks
        </span>

        <form onSubmit={(e) => e.preventDefault()} className="d-flex">
          <div className="input-group riskfilters-search-group">
            <input
              type="text"
              className="form-control riskfilters-search-input"
              placeholder="Risk, Business Unit, Process..."
              value={searchQuery}
              onChange={handleSearch}
              autoComplete="off"
            />
          </div>
        </form>

        <button className="btn riskfilters-btn yellow" onClick={onAddRessource}><i class="bi bi-box"></i> Ressource</button>
        <button className="btn riskfilters-btn red" onClick={onAddMenace}><i class="bi bi-bug"></i> Menace</button>
        <button className="btn riskfilters-btn blue" onClick={onAddMesure}><i class="bi bi-capsule"></i> Mesure</button>
        <button className="btn riskfilters-btn green" onClick={onAddNew}><i class="bi bi-plus-circle"></i> Risque</button>
        <button className="btn riskfilters-btn gray" onClick={resetFilters}><i class="bi bi-arrow-clockwise"></i></button>
        <button className="btn riskfilters-btn gray" onClick={handleCollapseReset}><i class="bi bi-x-square"></i></button>
      </div>

      <div className="riskfilters-grid">
        <div className="riskfilters-filter">
          <select
            name="risk_level"
            className="form-select riskfilters-select"
            value={filters.risk_level}
            onChange={handleChange}
          >
            <option value="">Toutes Criticités</option>
            <option value="high">Élevée</option>
            <option value="medium">Moyenne</option>
            <option value="low">Faible</option>
          </select>
        </div>

        <div className="riskfilters-filter">
          <select
            name="status"
            className="form-select riskfilters-select"
            value={filters.status}
            onChange={handleChange}
          >
            <option value="">Tous Statuts</option>
            <option value="open">Ouvert</option>
            <option value="mitigated">Réduit</option>
            <option value="archived">Archivé</option>
          </select>
        </div>

        <div className="riskfilters-filter">
          <select
            name="country"
            className="form-select riskfilters-select"
            value={filters.country}
            onChange={handleChange}
          >
            <option value="">Tous Pays</option>
            <option value="FR">France</option>
            <option value="DE">Allemagne</option>
            <option value="IT">Italie</option>
          </select>
        </div>
      </div>
    </div>
  );
}
